import axios from 'axios';
import Localbase from "localbase";
const db = new Localbase("db_dmis_desktop");

//const resource = 'http://localhost:3204'

const resource = process.env.VUE_APP_FORMS_URL


export class check {


  static admin1s() {
    return db.collection('admin_1').get().then(response => {
      return response
    });
    //return axios.get(resource + '/admin-1s/count').then(response => { return response });
  }

  static admin2s() {
    return db.collection('admin_2').get().then(response => {
      return response
    });
    //return axios.get(resource + '/admin-2s/count').then(response => { return response });
  }

  static admin3s() {
    return db.collection('admin_3').get().then(response => {
      return response
    });
    //return axios.get(resource + '/admin-3s/count').then(response => { return response });
  }

  static admin3gvhs() {
    return db.collection('admin_3gvhs').get().then(response => {
      return response
    });
    //return axios.get(resource + '/admin-3gvhs/count').then(response => { return response });
  }

  static admin3gvhvillages() {
    return db.collection('admin_3gvhvillages').get().then(response => {
      return response
    });
    //return axios.get(resource + '/admin-3gvhvillages/count').then(response => { return response });
  }

  static admin1s() {
    return db.collection('admin_1').get().then(response => {
      return response
    });
    //return axios.get(resource + '/admin-1s/count').then(response => { return response });
  }

}
